export default {
  laya: 'Die digitale Lernplattform zum inklusiven Lernen',
  imprint: 'Impressum',
  privacy: 'Datenschutz'
}



// WEBPACK FOOTER //
// ./src/i18n/footer/de.js